import React from 'react';
import {
  Box, 
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import View from './View';
import PageHeader from '../../components/PageHeader'
import Api from '../../../Api';
import SearchIcon from '@material-ui/icons/Search';
 
const useStyles = makeStyles((theme) => ({
  root: {
     background: '#f7f7fa',
    minHeight: '100%',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(3),
  },
}));

const EventView = () => {
  const classes = useStyles();
  return (
    <Page
      className={classes.root}
      title="List Auctions"
    >
       <Container maxWidth={false}>
   <PageHeader
  icon={<SearchIcon />}
  title="View Lots"
  subtitle="Search and view auction lots"
  showSession
/>
        <Box mt={3}>
          <View />
        </Box>
      </Container>
    </Page>
  );
};

export default EventView;
